import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './MessageAgentModal.scss';

const MAX_SMS_MESSAGE_LENGTH = 500;

export default class MessageAgentModal extends Component {
    static get propTypes() {
        return {
            responseId: PropTypes.number,
            isBuyer: PropTypes.bool,
            agentName: PropTypes.string,
            agentPhotoUrl: PropTypes.string,
            agentPhone: PropTypes.string,
            onMessageSent: PropTypes.func,
            onDimissModal: PropTypes.func,
            defaultMessage: PropTypes.string,
            ltk: PropTypes.string,
            ft: PropTypes.string,
            tracking: PropTypes.string,
            dynamicModules: PropTypes.string,
            agentId: PropTypes.string,
        };
    }

    state = {
        isLoading: false,
        message: this.props?.defaultMessage || '',
        messageLength: 0,
        questions: this.props?.isBuyer
            ? [
                {text: `Let's schedule a consultation. When can we meet?`},
                {text: `I have questions. Can we speak on the phone?`},
                {text: `What are the next steps for buying our new home?`}
            ]
            : [
                {text: `Let's schedule a consultation. When can we meet?`},
                {text: `I have questions. Can we speak on the phone?`},
                {text: `Can you prepare a comparative market analysis?`},
                {text: `What are the next steps for selling our home?`}
            ]
    };

    handleFormSubmit(event) {
        event.preventDefault();

        if(typeof UpNestAnalytics != 'undefined' && UpNestAnalytics != null) {
            const sell_or_buy = this.props?.isBuyer ? 'buy' : 'sell';
            UpNestAnalytics.trackEvent("message", {
                pageId: "proposal",
                linkName: 'message:send_message',
                modalName: 'message',
                modalTrigger: `${sell_or_buy}:proposal:${this.props?.tracking}${this.props?.ltk}${this.props?.ft}`,
                pageType: "proposal",
                siteSection: sell_or_buy,
                rdcTrackingEnabled: "y",
                agentId: this.props?.agentId,
                pageName: `${sell_or_buy}:proposal`,
                ...{dynamicModules: this.props?.dynamicModules}
            });
        }

        if (!this.state.message) {
            return;
        }

        this.setState({isLoading: true});

        const url = this.props?.isBuyer ? 'buyNeedMoreInfo-json' : 'needMoreInfo-json';
        $.post(url, {
            quoteId: this.props?.responseId,
            comment: this.state.message
        }).then(data => {
            if (!checkAjax(data, () => {}) || !data.quote) {
                defaultAjaxError(data.msg);
                return;
            }
            if (this.props?.onMessageSent) {
                this.props?.onMessageSent(data.quote);
            }
        }).fail(() => {
            defaultAjaxError();
        }).always(() => {
            this.setState({isLoading: false});
        });

        trackEvent('proposal', 'messageSendAgent').withGA();
    }

    handleQuestionClick(index) {
        const questions = this.state.questions;
        const question = questions[index];
        question.isSelected = !question.isSelected;

        let message = this.state.message;

        const containsQuestion = message.toLowerCase().includes(question.text.toLowerCase());
        if (question.isSelected) {
            if (!containsQuestion) {
                message = message + ' ' + question.text;
            }
        } else {
            message = message.replace(question.text, '');
        }
        message = message.replace(/\s+/, ' ').trim();

        this.setState({message, questions});
    }

    renderQuestion(index) {
        const question = this.state.questions[index];
        return (
            <li key={question.text}
                className={'question' + (question.isSelected ? ' selected' : '')}
                onClick={() => this.handleQuestionClick(index)}>
                {question.text}
            </li>
        );
    }

    onClickCancel() {
        if (this.props?.onDimissModal) {
            this.props?.onDimissModal();
        }
    }

    render() {
        const {agentName, agentPhotoUrl} = this.props;
        const {isLoading, message, questions, messageLength} = this.state;

        return (
            <form
                className="modal nu-modal mod message-agent-modal fade"
                role="dialog"
                onSubmit={this.handleFormSubmit.bind(this)}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                Send a message to {getFirstName(agentName)}
                                {agentPhotoUrl &&
                                    <img src={agentPhotoUrl} className="agent-photo" onError={event => replaceImageOnError(event.target, 'img/profile-icon-l.jpg')}/>
                                }
                            </div>
                        </div>
                        <div className="modal-body">
                            Pick any suggestions you might want to ask below:<br/>
                            <ul className={`suggestions`}>
                                {questions.map((_, index) => this.renderQuestion(index))}
                            </ul>
                            <div className="hidden-xs">Your message</div>
                            <textarea
                                className="form-control message-input"
                                placeholder="Type here any questions you want to ask the agent"
                                value={message}
                                disabled={isLoading}
                                onInput={e => this.setState({message: e.target.value})}
                                data-gramm="false"
                                data-gramm_editor="false"
                                data-enable-grammarly="false"
                                maxLength={MAX_SMS_MESSAGE_LENGTH}
                            />
                            <div className={`word-counter${message.length <= MAX_SMS_MESSAGE_LENGTH / 2 ?' transparent' : ''}${message.length >= MAX_SMS_MESSAGE_LENGTH * 0.1 ? ' close-to-limit' : ''}`}>
                                {(message.length> MAX_SMS_MESSAGE_LENGTH) ? (`${message.length} / ${MAX_SMS_MESSAGE_LENGTH}`) : (MAX_SMS_MESSAGE_LENGTH - message.length)}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-transparent" data-dismiss="modal" onClick={this.onClickCancel.bind(this)}>Cancel</button>
                            <button type="submit" className="btn btn-default" disabled={!message || isLoading || message.length > MAX_SMS_MESSAGE_LENGTH}>Send Message</button>
                        </div>
                        {isLoading &&
                            <div className="loadingSpinner" style="display: block; margin: 0">
                                <img src={global.imageBaseUrl + 'spinner.gif'}/>
                            </div>
                        }
                    </div>
                </div>
            </form>
        );
    }
}
